var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{attrs:{"tile":"","size":"90","color":_vm.data.meetingType.color}},[_c('v-icon',{attrs:{"size":"65","dark":_vm.isDarkTheme}},[_vm._v("mdi-calendar")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }